const SvgNoTask = (props) => (
  <svg
    width={138}
    height={123}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_15268_18034)">
      <path
        d="M124.294 98.9053C125.995 98.9053 127.373 97.5267 127.373 95.8261C127.373 94.1256 125.995 92.747 124.294 92.747C122.593 92.747 121.215 94.1256 121.215 95.8261C121.215 97.5267 122.593 98.9053 124.294 98.9053Z"
        fill="#F1F3F9"
      />
      <path
        d="M75.1645 111.729C105.955 111.729 130.918 86.7656 130.918 55.8643C130.918 24.963 105.955 0 75.1645 0C44.3731 0 19.4102 24.963 19.4102 55.8643C19.4102 86.7656 44.3731 111.729 75.1645 111.729Z"
        fill="#EAEEF9"
      />
      <path
        d="M109.912 7.24841C111.585 7.24841 113 8.52852 113 10.3207V100.953C113 102.617 111.713 104.025 109.912 104.025H42.8883C41.2159 104.025 39.8008 102.745 39.8008 100.953V10.3207C39.8008 8.65653 41.0872 7.24841 42.8883 7.24841H109.912Z"
        fill="#CED7E2"
      />
      <path
        d="M112.999 16.7213V100.825C112.999 102.489 111.713 103.897 109.912 103.897H48.6765L43.2734 98.5205L104.122 15.1851L109.397 13.265L112.999 16.7213Z"
        fill="#BCC4CF"
      />
      <path
        d="M109.654 14.2891C109.654 13.777 109.268 13.265 108.625 13.265H44.3026C43.788 13.265 43.2734 13.649 43.2734 14.2891V97.4964C43.2734 98.0084 43.6593 98.5205 44.3026 98.5205H108.496C109.011 98.5205 109.526 98.1364 109.526 97.4964L109.654 14.2891Z"
        fill="#D9DFEE"
      />
      <path
        d="M109.655 14.289C109.655 13.7769 109.269 13.2649 108.626 13.2649H44.3032C43.7887 13.2649 43.2741 13.6489 43.2741 14.289C44.0459 47.4439 44.3032 84.9512 40.7012 94.6801L102.322 93.784C106.053 76.8865 108.883 46.5478 109.655 14.289Z"
        fill="#EFF3FB"
      />
      <g filter="url(#filter0_d_15268_18034)">
        <path
          d="M109.526 13.3931C109.526 13.3931 109.398 18.3855 107.854 50.2603C107.854 50.5163 107.854 50.6443 107.854 50.9004C105.924 82.1351 78.1368 88.6637 74.792 89.0477C73.2483 89.1757 70.2894 89.4318 65.015 89.4318C58.4541 89.6878 48.4198 89.8158 32.7251 89.9438C32.2105 89.9438 31.8246 89.4318 32.0819 88.9197C42.8881 67.2858 43.0167 13.5211 43.0167 13.5211L109.526 13.3931Z"
          fill="white"
        />
      </g>
      <path
        d="M107.725 50.7723C105.924 82.007 78.0085 88.5356 74.6637 88.9196C73.12 89.0476 70.1612 89.3037 64.8867 89.3037C78.7804 82.9031 86.2418 71.3821 86.1131 62.4213C92.8027 62.9334 104.381 62.4213 107.725 50.7723Z"
        fill="#EAEEF9"
      />
      <path
        d="M92.0304 7.50454C92.0304 7.37653 92.0304 7.37653 92.0304 7.50454L91.3872 6.86449C91.3872 6.86449 91.0012 6.9925 90.8726 7.24852H80.8383C80.8383 6.9925 80.8383 6.86449 80.8383 6.60846C80.8383 4.56028 79.0372 2.76813 76.9789 2.76813C74.9206 2.76813 73.1196 4.56028 73.1196 6.60846C73.1196 6.86449 73.1196 6.9925 73.2482 7.12051H62.828C62.3134 7.12051 61.7988 7.50454 61.7988 8.27261V11.6009C61.7988 14.1611 63.5998 15.6972 66.0441 15.6972H87.3992C89.9721 15.6972 92.159 14.1611 92.159 11.6009V8.1446C92.2877 7.88858 92.159 7.63256 92.0304 7.50454Z"
        fill="#636F84"
      />
      <path
        d="M91.6452 7.50448V10.8328C91.6452 11.0888 91.6452 11.2168 91.6452 11.4728C91.2593 13.649 89.4582 15.4412 87.1426 15.4412H65.6588C63.3432 15.4412 61.5423 13.649 61.1562 11.4728C61.1562 11.2168 61.1562 11.0888 61.1562 10.8328V7.50448C61.1562 6.99244 61.5422 6.35238 62.1854 6.35238H72.7343C72.7343 6.09636 72.7343 5.96835 72.7343 5.84034C72.7343 3.79216 74.5353 2 76.5936 2C78.652 2 80.4531 3.79216 80.4531 5.84034C80.4531 6.09636 80.4531 6.22437 80.4531 6.35238H91.0019C91.2592 6.48039 91.6452 6.86443 91.6452 7.50448Z"
        fill="url(#paint0_linear_15268_18034)"
      />
      <path
        d="M76.3362 7.63247C77.3653 7.63247 78.1372 6.86441 78.1372 5.84032C78.1372 4.81623 77.3653 4.04816 76.3362 4.04816C75.307 4.04816 74.5352 4.81623 74.5352 5.84032C74.5352 6.86441 75.4357 7.63247 76.3362 7.63247Z"
        fill="#EAEEF9"
      />
      <path
        d="M91.5166 11.4729C91.1306 13.649 89.3295 15.4412 87.014 15.4412H65.6588C63.3432 15.4412 61.5423 13.649 61.1562 11.4729H91.5166Z"
        fill="#9AA1B2"
      />
      <path
        d="M90.5276 68.6923H60.8243C60.6202 68.6923 60.416 68.382 60.416 67.8647C60.416 67.4509 60.6202 67.0371 60.8243 67.0371H90.6296C90.8338 67.0371 91.0379 67.3475 91.0379 67.8647C91.0379 68.2785 90.8338 68.6923 90.5276 68.6923Z"
        fill="#AAB2C5"
      />
      <path
        d="M74.9211 73.6582H60.808C60.612 73.6582 60.416 73.3478 60.416 72.8305C60.416 72.4167 60.612 72.0029 60.808 72.0029H74.9211C75.1172 72.0029 75.3132 72.3133 75.3132 72.8305C75.3132 73.2444 75.1172 73.6582 74.9211 73.6582Z"
        fill="#AAB2C5"
      />
      <path
        d="M95.5849 31.4497H64.974C64.7644 31.4497 64.5547 31.1393 64.5547 30.6221C64.5547 30.2082 64.7644 29.7944 64.974 29.7944H95.5849C95.7946 29.7944 96.0042 30.1048 96.0042 30.6221C96.0042 31.1393 95.7946 31.4497 95.5849 31.4497Z"
        fill="#AAB2C5"
      />
      <path
        d="M94.7755 35.5876H83.1622C82.962 35.5876 82.7617 35.2773 82.7617 34.76C82.7617 34.3462 82.962 33.9324 83.1622 33.9324H94.7755C94.9758 33.9324 95.176 34.2427 95.176 34.76C95.176 35.2773 94.9758 35.5876 94.7755 35.5876Z"
        fill="#AAB2C5"
      />
      <path
        d="M79.8657 35.5876H64.9685C64.7616 35.5876 64.5547 35.2773 64.5547 34.76C64.5547 34.3462 64.7616 33.9324 64.9685 33.9324H79.8657C80.0726 33.9324 80.2795 34.2427 80.2795 34.76C80.2795 35.2773 80.0726 35.5876 79.8657 35.5876Z"
        fill="#AAB2C5"
      />
      <path
        d="M52.8989 36.4154C52.6804 36.4154 52.4619 36.3078 52.2435 36.0927L49.0759 33.081C48.7482 32.7583 48.7482 32.1129 49.0759 31.7903C49.4035 31.4676 50.0589 31.4676 50.3866 31.7903L52.8989 34.2642L58.0326 29.2088C58.3603 28.8861 59.0157 28.8861 59.3434 29.2088C59.6711 29.5315 59.6711 30.1769 59.3434 30.4995L53.5542 36.2003C53.3358 36.3078 53.1173 36.4154 52.8989 36.4154Z"
        fill="#AAB2C5"
      />
      <path
        d="M93.9402 49.6572H64.1349C63.9307 49.6572 63.7266 49.3468 63.7266 48.8296C63.7266 48.4158 63.9307 48.002 64.1349 48.002H93.9402C94.1443 48.002 94.3485 48.3123 94.3485 48.8296C94.3485 49.2434 94.1443 49.6572 93.9402 49.6572Z"
        fill="#AAB2C5"
      />
      <path
        d="M78.2069 54.623H64.1179C63.9222 54.623 63.7266 54.3127 63.7266 53.7954C63.7266 53.3816 63.9222 52.9678 64.1179 52.9678H78.2069C78.4026 52.9678 78.5983 53.2781 78.5983 53.7954C78.6961 54.2092 78.5004 54.623 78.2069 54.623Z"
        fill="#AAB2C5"
      />
      <path
        d="M51.6569 54.6229C51.4553 54.6229 51.2536 54.5153 51.052 54.3002L48.2288 51.2885C47.9263 50.9658 47.9263 50.3205 48.2288 49.9978C48.5313 49.6751 49.1363 49.6751 49.4387 49.9978L51.7577 52.4717L56.4966 47.4163C56.7991 47.0936 57.404 47.0936 57.7065 47.4163C58.009 47.739 58.009 48.3844 57.7065 48.7071L52.2619 54.3002C52.1611 54.5153 51.9594 54.6229 51.6569 54.6229Z"
        fill="#AAB2C5"
      />
      <path
        d="M48.3464 73.658C48.1447 73.658 47.9431 73.5505 47.7414 73.3354L44.9183 70.3237C44.6158 70.001 44.6158 69.3556 44.9183 69.0329C45.2207 68.7103 45.8257 68.7103 46.1282 69.0329L48.4472 71.5068L53.1861 66.4515C53.4885 66.1288 54.0935 66.1288 54.396 66.4515C54.6985 66.7742 54.6985 67.4195 54.396 67.7422L48.9513 73.3354C48.8505 73.5505 48.6489 73.658 48.3464 73.658Z"
        fill="#AAB2C5"
      />
      <path
        d="M125.534 95.4587C125.109 97.2643 124.472 99.1761 123.728 100.769C121.71 104.699 118.524 107.779 114.594 109.797C110.558 111.815 105.779 112.665 100.999 111.603C89.7407 109.266 82.5184 98.2202 84.855 86.9618C87.1917 75.7035 98.1314 68.3749 109.39 70.8178C113.426 71.6675 116.931 73.6855 119.905 76.447C124.897 81.4389 127.021 88.6612 125.534 95.4587Z"
        fill="url(#paint1_linear_15268_18034)"
      />
      <path
        d="M111.181 94.5896L107.802 91.2103L111.181 87.8307C111.857 87.1548 111.932 86.0279 111.181 85.2769C110.505 84.6009 109.379 84.5263 108.628 85.2773L105.248 88.657L101.868 85.277C101.193 84.6011 100.066 84.5259 99.3149 85.277C98.5639 86.028 98.564 87.0794 99.315 87.8304L102.695 91.2104L99.3154 94.59C98.6394 95.2659 98.564 96.3921 99.3149 97.1431C99.9909 97.8191 101.118 97.8944 101.869 97.1434L105.248 93.7638L108.628 97.143C109.304 97.819 110.43 97.8944 111.181 97.1434C111.932 96.3923 111.857 95.2656 111.181 94.5896Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_15268_18034"
        x={10}
        y={2.39313}
        width={121.525}
        height={120.551}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_15268_18034"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_15268_18034"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_15268_18034"
        x1={61.1931}
        y1={8.72226}
        x2={91.6745}
        y2={8.72226}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset={1} stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_15268_18034"
        x1={84.3969}
        y1={91.2097}
        x2={126.007}
        y2={91.2097}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset={1} stopColor="#969EAE" />
      </linearGradient>
      <clipPath id="clip0_15268_18034">
        <rect width={138} height={123} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNoTask;
